'use strict';

import Flatpickr from "flatpickr";
import { Polish } from "flatpickr/dist/l10n/pl.js";

var inputDate= function () {
  var Flatpickr = require('flatpickr');

  Flatpickr('.js-input-date', {
    altInput: true,
    altFormat: " j F",
    dateFormat: "d-m-Y",
    "locale": Polish
  });

};

module.exports = inputDate;
